
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.7093 6.81683C19.3444 6.90914 19.7956 7.22942 19.9469 7.69558C20.0985 8.16174 19.9218 8.68603 19.4622 9.13403L15.7167 12.7849L16.6008 17.9404C16.7141 18.5997 16.5213 18.9949 16.3398 19.2102C16.1267 19.4629 15.8159 19.6022 15.465 19.6022C15.2008 19.6021 14.9199 19.5248 14.63 19.3724L10 16.9383L5.37019 19.3724C5.08027 19.5248 4.79936 19.6021 4.53507 19.6021C4.18412 19.6021 3.8736 19.4629 3.66044 19.2102C3.47886 18.9949 3.28614 18.5997 3.39921 17.9404L4.28361 12.7849L0.537874 9.13388C0.078278 8.68603 -0.0984191 8.16174 0.0529484 7.69558C0.204316 7.22942 0.655519 6.90914 1.29059 6.81683L6.46715 6.06456L8.78176 1.3743C9.06588 0.798738 9.50991 0.468689 10 0.468689C10.4901 0.468689 10.9342 0.798738 11.2181 1.3743L13.533 6.06456L18.7093 6.81683Z"}})])
          )
        }
      }
    